(function () {
  const ROOT_CLASS = 'desktop4-chart-interactive';
  const FULLSCREEN_CLASS = 'chart-fullscreen';
  const TRISTATE_CLASS = 'tri-state';
  const MODE_ROTATE_CLASS = 'mode-rotate';
  const MODE_MOVE_CLASS = 'mode-move';
  const WIDE_LAYOUT_MIN_WIDTH = 1100;

  let selectedMode = null;
  let fullscreenForced = false;
  let isCoarsePointer = false;
  let container = null;

  function isCoarsePointerDevice() {
    return window.matchMedia('(any-pointer: coarse)').matches ||
      window.matchMedia('(pointer: coarse)').matches ||
      navigator.maxTouchPoints > 0;
  }

  function isPortraitMobile() {
    const root = document.documentElement;
    if (!root.classList.contains('desktop4-scaled-page') ||
      !root.classList.contains('desktop4-portrait-accepted')) {
      return false;
    }
    const portrait = window.matchMedia
      ? window.matchMedia('(orientation: portrait)').matches
      : window.innerHeight >= window.innerWidth;
    return portrait && window.innerWidth < WIDE_LAYOUT_MIN_WIDTH;
  }

  function isSwitcherVisible() {
    return isCoarsePointer && isPortraitMobile();
  }

  function isMainChartFullscreen() {
    return document.body.classList.contains(FULLSCREEN_CLASS);
  }

  function isLandscapeTouchLayout() {
    return document.documentElement.classList.contains('desktop4-scaled-page') &&
      document.documentElement.classList.contains('desktop4-landscape');
  }

  function isForced() {
    return fullscreenForced || isMainChartFullscreen() || isLandscapeTouchLayout();
  }

  function isEffectivelyEnabled() {
    if (!isCoarsePointer) {
      return true;
    }
    if (isForced()) {
      return true;
    }
    return isSwitcherVisible() && selectedMode !== null;
  }

  function getMainAction() {
    return selectedMode === 'move' ? 'move' : 'rotate';
  }

  function syncDomState() {
    const root = document.documentElement;
    root.classList.toggle(ROOT_CLASS, isEffectivelyEnabled() && isCoarsePointer);

    if (container) {
      const visible = isSwitcherVisible();
      container.classList.toggle('show', visible);
      container.classList.toggle(MODE_ROTATE_CLASS, visible && selectedMode === 'rotate');
      container.classList.toggle(MODE_MOVE_CLASS, visible && selectedMode === 'move');
    }

    window.StockStorm3DInteraction?.setMainAction?.(getMainAction());
  }

  function selectMode(mode) {
    if (!isSwitcherVisible()) {
      return;
    }
    selectedMode = selectedMode === mode ? null : mode;
    if (selectedMode === null) {
      window.StockStorm3DInteraction?.resetGestureState?.();
    }
    syncDomState();
  }

  function handleFullscreenChange() {
    if (!isCoarsePointer) {
      return;
    }
    if (isMainChartFullscreen()) {
      fullscreenForced = true;
    } else {
      fullscreenForced = false;
      selectedMode = null;
      window.StockStorm3DInteraction?.resetGestureState?.();
    }
    syncDomState();
  }

  function init() {
    isCoarsePointer = isCoarsePointerDevice();
    selectedMode = null;
    fullscreenForced = false;

    window.StockStorm3DInteraction = window.StockStorm3DInteraction || {};
    window.StockStorm3DInteraction.isEnabled = isEffectivelyEnabled;
    window.StockStorm3DInteraction.getMainAction = getMainAction;

    container = document.querySelector('#main-block .chart-wrapper .rotate-move-switcher-container');
    if (container && isCoarsePointer) {
      container.classList.add(TRISTATE_CLASS);

      const rotateBtn = container.querySelector('.item-rotate');
      const moveBtn = container.querySelector('.item-move');

      if (rotateBtn) {
        rotateBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          selectMode('rotate');
        });
      }
      if (moveBtn) {
        moveBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          selectMode('move');
        });
      }
    }

    const observer = new MutationObserver(handleFullscreenChange);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    syncDomState();
    window.addEventListener('resize', syncDomState);
    window.addEventListener('orientationchange', syncDomState);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
